import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Builder } from '@builder.io/react';
import { css } from '@emotion/react';
import { Colors, Shadows } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { SignUpForm as ZapierSignUpForm } from '@zapier/authentication';
const styles = labelStyles('SignUpForm', {
    root: css({
        maxWidth: '370px',
        margin: '0 auto',
        padding: '25px 20px',
        borderRadius: '20px',
        backgroundColor: Colors.neutral100,
        boxShadow: Shadows.elevation5,
    }),
    placeholder: css({
        width: '375px',
        height: '455px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: Colors.gray60,
    }),
});
export function SignUpForm({ hideFieldsUntilFocus = true, facebookSSOEnabled = true, googleSSOEnabled = true, microsoftSSOEnabled = true, }) {
    return (_jsx("div", Object.assign({ css: styles.root }, { children: Builder.isEditing ? (_jsx("div", Object.assign({ css: styles.placeholder }, { children: "Sign up form" }))) : (_jsx(ZapierSignUpForm, { facebookSSOEnabled: facebookSSOEnabled, googleCaptchaSiteKey: "6Lda9zoUAAAAAOwhmrgGDo_l4zcHOYWujO9Q_qnS", googleSSOEnabled: googleSSOEnabled, hideFieldsUntilFocus: hideFieldsUntilFocus, microsoftSSOEnabled: microsoftSSOEnabled })) })));
}
//# sourceMappingURL=SignUpForm.js.map